import { useRef } from "react";
import { animated, useSpring } from "@react-spring/web";
import { useGesture } from "@use-gesture/react";
import styles from "./Image.module.css";

const Image = (props: {
  src: string;
  onClick: (index: number) => void;
  id: number;
  width?: number;
  blur?: boolean;
}) => {
  const imgRef = useRef(null);
  const [{ scale }, api] = useSpring(() => ({ scale: 1 }));

  useGesture(
    {
      onHover: ({ hovering }) => api.start({ scale: hovering ? 1.1 : 1 }),
    },
    { target: imgRef }
  );

  return (
    <animated.div
      ref={imgRef}
      style={{
        transform: scale.to((s) => `scale(${s})`),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        onClick={() => props.onClick(props.id)}
        className={styles.images}
        style={{
          background: `url(${props.src.replace(
            /(\r\n|\n|\r)/gm,
            ""
          )}) center center`,
          width: props.width,
          height: props.width,
          filter: props.blur ? "blur(3px)" : "none",
        }}
      ></div>
      {/*<img*/}
      {/*  src={props.src}*/}
      {/*  alt="random"*/}
      {/*  onClick={() => props.onClick(props.id)}*/}
      {/*  width={props.width}*/}
      {/*  style={{*/}
      {/*    filter: props.blur ? "blur(3px)" : "none",*/}
      {/*  }}*/}
      {/*/>*/}
    </animated.div>
  );
};

export default Image;
